import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { LinksService } from '@boels/helpers';
import { BoelsBaseSite, Language } from '@boels/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'boels-language-selector-page-item-link',
  templateUrl: './language-selector-page-item-link.component.html',
  styleUrls: ['./language-selector-page-item-link.component.scss'],
  imports: [FontAwesomeModule, RouterModule],
})
export class LanguageSelectorPageItemLinkComponent implements OnChanges {
  protected boelsLinksService = inject(LinksService);

  @Input()
  baseSite: BoelsBaseSite;

  @Input()
  language: Language;

  @Input()
  urlAfterRedirects: string;

  @Output()
  languageEventEmitter = new EventEmitter<Language>();

  url: string;
  faChevronRight = faChevronRight;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['baseSite'] ||
      changes['language'] ||
      changes['urlAfterRedirects']
    ) {
      this.url = this.getLinkUrl()?.replace('//', '/');
    }
  }

  getLinkUrl(): string {
    const cultureUri = this.boelsLinksService.cultureBuilder(
      this.baseSite,
      this.language,
    );
    const uriAfterRedirects = this.urlAfterRedirects || '';

    return this.boelsLinksService.urlBuilder(cultureUri, uriAfterRedirects);
  }

  emitLanguage(): void {
    this.languageEventEmitter.emit(this.language);
  }
}
